import {styled} from "@mui/material/styles"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import {Box} from "@mui/material"
import {Container} from "../../component"

export const StyledContainer = styled(Container)`
    @media (min-width: ${breakpoints.values.md}px) {
        min-width: 6.5rem;
        height: 2.25rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        min-width: 6.25rem;
        height: 2.25rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        min-width: 10rem;
        height: 2.25rem;
    }
`

export const StyledBox = styled(Box)`
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY};
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    a {
        max-height: 2.25rem;
    }
`
